import React, { useState } from 'react';
import PushPinIcon from '@mui/icons-material/PushPin';

const LocationSearchPanel = ({
  suggestions,
  setVehiclePanel,
  setPanelOpen,
  setPickupLocation,
  setLatitude,
  setLongitude,
  setDropLatitude,
  setDropLongitude,
  setDropLocation,
  activeField,
  setShowSlideUp,
  setIsPickupValid,
  setIsDropValid,
}) => {
  const [selectedIdx, setSelectedIdx] = useState(null);

  const handleSuggestionClick = (suggestion, idx) => {
    setSelectedIdx(idx);
    console.log('suggestion.foratted', suggestion, suggestion?.geometry?.location?.lng)
    if (activeField === 'pickup') {
      setPickupLocation(suggestion.formatted_address);
      setLatitude(suggestion?.geometry?.location?.lat)
      setLongitude(suggestion?.geometry?.location?.lng)
      localStorage.setItem('pickupLoc', suggestion.formatted_address);
      localStorage.setItem('pickLatitude', suggestion?.geometry?.location?.lat);
      localStorage.setItem('pickLongitude', suggestion?.geometry?.location?.lng);
      setShowSlideUp(false);
      setIsPickupValid(true);
    } else if (activeField === 'destination') {
      setDropLocation(suggestion.formatted_address);
      setDropLatitude(suggestion?.geometry?.location?.lat)
      setDropLongitude(suggestion?.geometry?.location?.lng)
      localStorage.setItem('dropLoc', suggestion.formatted_address);
      localStorage.setItem('dropLatitude', suggestion?.geometry?.location?.lat);
      localStorage.setItem('dropLongitude', suggestion?.geometry?.location?.lng);
      setShowSlideUp(false);
      setIsDropValid(true);
    }
  };

  return (
    <div className="space-y-1">
      {suggestions.map((elem, idx) => (
        <div
          key={idx}
          onClick={() => handleSuggestionClick(elem, idx)}
          className={`
            flex items-start gap-3 p-1 rounded-lg cursor-pointer 
            transition-colors duration-200
            ${selectedIdx === idx ? 'bg-blue-100' : 'hover:bg-gray-100'}
          `}
        >
          <div className="text-lg">📍</div>
          <div className="text-[11px] font-medium leading-tight mt-[0.5rem]">
            {elem.formatted_address}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LocationSearchPanel;



// import React, { useState } from 'react';
// import PushPinIcon from '@mui/icons-material/PushPin';

// const LocationSearchPanel = ({
//   suggestions,
//   setVehiclePanel,
//   setPanelOpen,
//   setPickupLocation,
//   setDropLocation,
//   activeField,
//   setShowSlideUp
// }) => {
//   const [selectedIdx, setSelectedIdx] = useState(null);

//   const handleSuggestionClick = (suggestion, idx) => {
//     setSelectedIdx(idx);
//     if (activeField === 'pickup') {
//       setPickupLocation(suggestion.formatted_address);
//       localStorage.setItem('pickupLoc', suggestion.formatted_address);
//       setShowSlideUp(false);
//     } else if (activeField === 'destination') {
//       setDropLocation(suggestion.formatted_address);
//       localStorage.setItem('dropLoc', suggestion.formatted_address);
//       setShowSlideUp(false);
//     }
//   };

//   return (
//     <div className="space-y-1">
//       {suggestions.map((elem, idx) => (
//         <div
//           key={idx}
//           onClick={() => handleSuggestionClick(elem, idx)}
//           className={`
//             flex items-start gap-3 p-3 rounded-lg cursor-pointer
//             transition-colors duration-200
//             ${selectedIdx === idx ? 'bg-blue-100' : 'hover:bg-gray-100'}
//           `}
//         >
//           <div className="pt-1 text-lg">📍</div>
//           <div className="text-sm font-medium leading-tight">
//             {elem.formatted_address}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default LocationSearchPanel;





// import React, { useState } from 'react';
// import PushPinIcon from '@mui/icons-material/PushPin';

// const LocationSearchPanel = ({
//   suggestions,
//   activeField,
//   setPickupLocation,
//   setDropLocation,
//   setLatitude,         // ★ FIX
//   setLongitude,        // ★ FIX
//   setDropLatitude,     // ★ FIX
//   setDropLongitude,    // ★ FIX
//   setShowSlideUp,
//   setIsPickupSelectedFromSuggestion,
//   setIsDropSelectedFromSuggestion,
// }) => {
//   const [selectedIdx, setSelectedIdx] = useState(null);

//   const handleSuggestionClick = (s, idx) => {
//     setSelectedIdx(idx);

//     // Extract coordinates from OLA response
//     const lat = s?.geometry?.location?.lat;
//     const lng = s?.geometry?.location?.lng;

//     if (activeField === 'pickup') {
//       setPickupLocation(s.formatted_address);
//       setLatitude(lat);           // ★ FIX
//       setLongitude(lng);          // ★ FIX

//       localStorage.setItem('pickupLoc', s.formatted_address);
//       localStorage.setItem('pickLatitude', lat);
//       localStorage.setItem('pickLongitude', lng);

//       setIsPickupSelectedFromSuggestion(true);
//     } else if (activeField === 'destination') {
//       setDropLocation(s.formatted_address);
//       setDropLatitude(lat);       // ★ FIX
//       setDropLongitude(lng);      // ★ FIX

//       localStorage.setItem('dropLoc', s.formatted_address);
//       localStorage.setItem('dropLatitude', lat);
//       localStorage.setItem('dropLongitude', lng);

//       setIsDropSelectedFromSuggestion(true);
//     }
//     setShowSlideUp(false);
//   };

//   return (
//     <div className="space-y-1">
//       {suggestions.map((el, i) => (
//         <div
//           key={i}
//           onClick={() => handleSuggestionClick(el, i)}
//           className={`flex items-start gap-3 p-3 rounded-lg cursor-pointer transition-colors
//             ${selectedIdx === i ? 'bg-blue-100' : 'hover:bg-gray-100'}`}
//         >
//           <div className="pt-1 text-lg">📍</div>
//           <div className="text-sm font-medium leading-tight">{el.formatted_address}</div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default LocationSearchPanel;
